import { render, staticRenderFns } from "./BatchList.vue?vue&type=template&id=083515bf&scoped=true"
import script from "./BatchList.vue?vue&type=script&lang=ts"
export * from "./BatchList.vue?vue&type=script&lang=ts"
import style0 from "./BatchList.vue?vue&type=style&index=0&id=083515bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083515bf",
  null
  
)

export default component.exports